function adjustHeight() {
  const otherDiv = document.getElementById('stick_cont');
  const mainContentHeight = document.getElementById('MainContent').offsetHeight;

  // Establece la altura de otherDiv como la altura del contenido principal
  if (window.innerWidth <= 768) {
    otherDiv.style.height = 'auto'; // Ajusta la altura al 90% de la altura de la ventana
  } else {
    // Para dispositivos no móviles, establece la altura de otherDiv como la altura del contenido principal
    otherDiv.style.height = mainContentHeight + 'px';
  }
}

// Resto del código...
function observeChanges() {
    const targetNode = document.querySelector('.cc-accordion-item');
    const config = { attributes: true, attributeFilter: ['class'] };

    const callback = function(mutationsList, observer) {
        for(const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (targetNode.classList.contains('is-open')) {
                    adjustHeight();
                } else {
                    document.getElementById('stick_cont').style.height = 0;
                }
            }
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}

function adjustHeightOnScroll() {
    adjustHeight();
}

// Llama a la función para observar cambios en el DOM
observeChanges();

// Ajusta la altura cuando se carga la página
adjustHeight();

// Ajusta la altura cuando se desplaza la página
window.addEventListener('scroll', adjustHeightOnScroll);